var englishTranslations = {
    translation: {
        alertsCategoriesTitles: {
            balanceAlerts: 'Balance Alerts',
            paymentAlerts: 'Payment Alerts',
            profileAlerts: 'Profile Alerts',
            spendingAlerts: 'Spending Alerts',
            securityAlerts: 'Security Alerts',
            uncategorized: 'Uncategorized Alerts',
            payLaterAlerts: 'Pay Later Loan Alerts'
        },
        alertsCategoriesSubtitle: {
            securityAlerts: 'For your security, you will always receive an email for the following alerts and they cannot be turned off.'
        },
        alertsTitle: {
            auto_pay: 'Payments',
            authorized_user: 'Authorized User',
            available_credit: 'Available credit is within $%s of credit limit ',
            generous_tip: 'Generous tip exceeds %s %',
            balance_exceeds: 'Balance exceeds $%s',
            balance_overlimit: 'Balance exceeds credit limit',
            freeze_account: 'Freeze Account',
            international_transaction: 'International transaction occurs',
            payment_past_due: 'Missed payment',
            payment_reminder: 'Payment or Autopay is due in %d days',
            payment_scheduled: 'Payment is scheduled',
            profile_change: 'Profile Change',
            profile_change_address: 'Profile Address Changes',
            profile_change_email: 'Profile Email Changes',
            profile_change_name: 'Profile Name Changes',
            profile_change_phone: 'Profile Phone Changes',
            promo_purchase_expiry: 'Promotional purchase will expire in %d days',
            statement_available: 'Statement is available',
            transaction_over_user_creditlimit: 'Transaction is over $%s',
            transaction_refund: 'Credit or refund is posted',
            transaction_card_not_present: 'Online, phone, or mail transaction occurs',
            transaction_decline: 'Declined transactions',
            statement_ready: 'Paperless Statement',
            select_the_account: 'Select the account you want to manage alerts for.',
            approved_transactions: 'Approved transactions',
            purchase_exceeds: 'Approved transactions over $%s',
            transaction_authorization: 'All approved transactions',
            special_financing: 'A special financing purchase will expire in %d days',
            syf_pay_later: 'Loan alerts and reminders'
        },
        marketingPrivacySettingsTitle: {
            marketingSettings: 'Marketing Settings',
            privacySettings: 'Privacy Settings',
            selectAccount: 'Select the account you want to manage your marketing and privacy preferences for.'
        },
        marketingPrivacySettings: {
            successMessage: 'Your changes have been saved.',
            errorMessage: 'We couldn’t save your changes. Please try again.'
        },
        alertsSubTitle: {
            auto_pay: 'Autopay, payment scheduled, payment posted',
            freeze_account: 'Confirmation that account has been temporarily frozen',
            profile_change: 'Your personal information (address, email, or phone) has been changed',
            statement_ready: 'Your statement is available online'
        },
        alertsBody: {
            leftDescription: 'Send alert when:',
            leftDescriptionSyfPayLaterOrApprovedTransactions: 'Send alert for:',
            rightDescription: 'Send alert to:',
            addMobileNumber: 'Add mobile number'
        },
        marketingPrivacySettingsBodyTitle: {
            marketingSettings: 'Choose how you hear from us about other Synchrony products.',
            privacySettingsEnrolled: 'I agree to share my information.',
            privacySettingsUnenrolled: 'Do not share my information.'
        },
        marketingPrivacySettingsError: {
            title: 'We’re sorry',
            infoNotAvailable: 'Unfortunately, we can’t retrieve your marketing and privacy settings right now. Please try again later.'
        },
        inputLabels: {
            available_credit: 'Your available credit is within this amount of the credit limit.',
            generous_tip: 'A tip exceeds this percentage on a transaction:',
            balance_exceeds: 'The balance on this account exceeds: ',
            balance_overlimit: 'The account balance exceeds the account credit limit. ',
            international_transaction: 'An international transaction occurs on this account.',
            payment_past_due: 'The minimum payment due on your account has not been received.',
            payment_reminder: 'A payment or Autopay is due in: ',
            payment_scheduled: 'A payment is scheduled to be made on this account.',
            promo_purchase_expiry: 'A promotional purchase will expire in:',
            statement_available: 'Statement is available',
            transaction_over_user_creditlimit: 'A transaction occurs that is over:',
            transaction_refund: 'A merchant credit or refund is posted to this account.',
            transaction_card_not_present: 'An online, phone, or mail transaction occurs.',
            transaction_decline: 'A transaction is declined.',
            special_financing: 'A special financing purchase will expire in: ',
            syf_pay_later: 'Any payment and account activities related to your Synchrony Pay Later account.'
        },
        inputPlaceHolders: {
            available_credit: 'Amount',
            generous_tip: 'Tip Percentage',
            select_account: 'Select Account',
            balance_exceeds: 'Amount',
            payment_reminder: 'Select Days',
            promo_purchase_expiry: 'Select Days',
            transaction_over_user_creditlimit: 'Amount',
            purchase_exceeds: 'Amount',
            approved_transactions: 'Amount'
        },
        inputHelperText: {
            available_credit: 'Whole dollar amount only',
            generous_tip: 'Whole numbers between 1 and 200 only',
            balance_exceeds: 'Whole dollar amount only',
            transaction_over_user_creditlimit: 'Whole dollar amount only',
            purchase_exceeds: 'Whole dollar amount only',
            approved_transactions: 'Whole dollar amount only'
        },
        deliveryIconsTitle: {
            email: 'Email',
            text: 'Text',
            push: 'App',
            clientNotification: 'Client',
            mail: 'Direct Mail'
        },
        buttonLabels: {
            turnOn: 'TURN ON',
            turnOff: 'TURN OFF',
            save: 'SAVE',
            cancel: 'CANCEL',
            close: 'CLOSE',
            edit: 'EDIT',
            updatePhoneOrEmail: 'Update phone or email',
            updateConsent: 'UPDATE CONSENT',
            updateContactInformation: 'Update contact information'
        },
        accountSummaryPage: {
            navigationButtonLabel: 'GET ALERTS'
        },
        errorPage: {
            navigationButtonLabel: 'Back',
            title: 'Oops...',
            fourHundred: 'Unfortunately we are unable to process your request at this time. Please try again later.',
            fiveHundred: 'Unfortunately we are experiencing technical issues on our end. Please try again later.',
            default: 'Unfortunately we are unable to process your request at this time. Please try again later.',
            code: 'Code:',
            unregisteredHint: 'If your account is not registered, please return to Account Manager to register your account.',
            accountsDataNotAvailable: 'Unfortunately, we are unable to retrieve your alerts information at this time. Please try again later.'
        },
        errorTitles: {
            page: 'Network Error'
        },
        errorMessages: {
            approvedTrnxType: 'Please make a selection',
            amountTextField: 'Please enter a valid amount. Whole dollar amounts only',
            percentageTextField: 'Please enter a valid amount. Whole numbers between 1 and 200 only',
            deliveryMethod: 'Select at least one delivery method.',
            updatePreference: 'Sorry, we are unable to save your changes at this time. Please try again later.',
            mailOrPhoneBeforeLink: 'Alert enrollment was unsuccessful because your contact information is missing. Please ',
            mailOrPhonePreferenceLink: 'update your profile here',
            mailOrPhoneAfterLink: 'and try again.',
            code: 'Code',
            syfPayLaterDeliveryMethod: 'Select Text to enroll in text alerts.',
            syfPayLaterSubText: 'Email is always sent.'
        },
        headerLabels: {
            backToAccountSummary: 'back to account summary',
            getAlerts: 'Get Alerts',
            alertsManagement: 'Alerts Management',
            marketingPrivacySettings: 'Marketing & Privacy Settings'
        },
        footerLabels: {
            copyRightBy: 'Synchrony',
            internetPrivacyPolicy: 'Internet Privacy Policy',
            privacyPolicy: 'Privacy Policy',
            websiteUsageAgreement: 'Website Usage Agreement'
        },
        toolTip: {
            email: 'We will always send you an email for this alert and it cannot be turned off',
            autopay: 'If you are enrolled in Autopay, you will receive an Autopay reminder.',
            emailText: 'We will always send you an email and text for this alert and it cannot be turned off',
            emailPush: 'We will always send you an email and app notification for this alert and it cannot be turned off',
            emailTextPush: 'We will always send you an email, text and app notification for this alert and it cannot be turned off',
            text: 'We will always send you a text for this alert and it cannot be turned off',
            textPush: 'We will always send you a text and app notification for this alert and it cannot be turned off',
            push: 'We will always send you an app notification for this alert and it cannot be turned off'
        },
        termsAndConditions: {
            title: 'Text and Email Account Alerts Terms & Conditions',
            phoneLabel: 'Phone Number',
            emailLabel: 'Email Address',
            acknowledgeLabel: 'I agree to the above Terms and Conditions.',
            linkLabel: 'Text and Email Account Alert Terms and Conditions.',
            contentBeforeLink: "By checking the box below and clicking \u201CSAVE,\u201D you AGREE to the ",
            contentAfterLink: " If you elect to receive alerts via text, but prior to making such election, you had revoked consent for us to user automated technology to call or text mobile numbers you give to us, you also agree that, upon electing to receive text alerts, you consent to us using automated technology to call or text such numbers under the terms of the communications consent set forth in the agreement governing your account \u201CCredit Agreement Consent,\u201D including for the purpose of  texting you the account alerts you select and for other account-related purposes. You agree that if you seek to terminate  account alerts via text, such termination will apply only to account alert texts and will not terminate other texts for which we have your consent. Message and data rates may apply. As to account alerts sent via text, text STOP to terminate such alerts and HELP for help.",
            vistaContentBeforeLink: "Alerts will be sent to the email address and phone number in your profile."
        },
        termsConsentBanner: {
            title: 'Please Update Your Consent',
            mainContentManageAlerts: "To continue receiving text alerts regarding your account, please click \u201CUPDATE CONSENT\u201D below, and agree to the Terms and Conditions."
        },
        a11y: {
            alertIsOn: 'Alert On',
            alertIsOff: 'Alert Off'
        },
        phoneWarning: {
            linkLabel: 'add a phone number to your profile',
            contentBeforeLink: 'Please ',
            contentAfterLink: ' to enroll in text alerts.'
        },
        smsTermsAndConditionLink: {
            termsAndConditionText: 'By enrolling in Text and/or Email Alerts you are agreeing to these ',
            termsAndConditionLink: 'Terms.'
        },
        successModal: {
            title: 'Success!',
            content: 'We have saved your changes.',
            closeSuccessModal: 'CLOSE'
        },
        approvedTransactionInfo: {
            approvedTransactionLabel: 'All transactions',
            purchaseExeedsLabel: 'All transactions over a specified amount',
            content: 'Notifications can include recurring and international charges, as well as online, mail or phone orders (card not present).',
            radioGroupLabel: 'Approved transactions Alert'
        },
        syfPayLaterInfo: {
            content: "You'll always receive emails regarding your Pay Later loan account and those cannot be turned off. If you'd like to also receive text alerts, add that option here."
        },
        helperText: {
            day: ' day',
            onStatus: 'ON',
            offStatus: 'OFF',
            atWord: 'at'
        },
        adaHelperText: {
            successBanner: 'Showing success banner.',
            termsConditions: 'Showing terms and conditions.'
        },
        maintenancePage: {
            title: 'Temporarily Down for Maintenance',
            knownTime: 'We expect to be back on %t EST. Thanks for your patience.',
            unknownTime: 'Please check back later. We apologize for the inconvenience and appreciate your patience!'
        },
        dropdown: {
            days: 'days',
            day: 'day',
            endingIn: 'ending in'
        },
        contactInformation: {
            title: 'Contact Information',
            content: 'Receive email and text alerts for important actions on your account. Alerts will be sent to the email address and phone number in your profile.',
            marketingSettingsContent: 'Marketing communications will be sent to the contact information in your profile.',
            phoneTitle: 'Phone Number',
            emailTitle: 'Email Address',
            addressTitle: 'Address',
            noPhoneNumberAvailable: 'No number on file'
        },
        marketingSettingsBodyDisclaimerText: {
            content: 'Your preferences here will not affect communications like alerts about your account activity and service-related emails.'
        },
        privacySettings: {
            policyText: 'You have options for what and how we share with certain third parties.',
            policyLink: 'Click here to review our Privacy Policy.',
            legalText: "To limit the information we share, please check the box below. Checking the box means we won't share your information related to this card account with companies outside the Synchrony Family, beyond the retailer for this card and affiliates and as otherwise permitted by law, as described in our privacy Policy. We will also not share information about your creditworthiness in connection with your account number with companies within the Synchrony Family, as defined in the Privacy Policy.",
            disclaimerText: 'Please note that Synchrony Bank will continue to share information with our affiliates, joint marketing partners and service providers and as otherwise permitted by law, as described in our Privacy Policy. ',
            acknowledgeLabel: "Please don't share information connected with my account outside the Synchrony Family, the retailer for this card and its affiliates, and as otherwise permitted by law. Please don't share information about my creditworthiness in connection with this account with companies within the Synchrony Family, as defined in the Privacy Policy."
        },
        alertsNotAvailableInfo: {
            title: 'Oops...',
            content: 'Unfortunately, alerts management is not available for this account.'
        }
    }
};
export default englishTranslations;
